import "../../css/vendorQuoteRequests.css";
import { getImageUrl } from "../helpers/mediaUrl";

/**
 * Vendor Quote Requests Component
 * Handles the vendor-side: browsing requests, submitting quotes, tracking status, and negotiation.
 */
export default class vendorQuoteRequests {
  constructor() {
    console.info("Vendor Quote Requests — Loaded");
    this.vendorId = null;
    this.init();
    this.bindEvents();
    window.vendorQuoteRequests = this; // Global access for manual refresh
  }

  refresh = () => {
    console.info("Vendor Quote Requests — Refreshing data...");
    this.loadAvailableRequests();
    this.loadOrders();
    this.loadNotificationBadge();
  };

  init = () => {
    this.loadAvailableRequests();
    this.loadNotificationBadge();
  };

  bindEvents = () => {
    // Tabs
    $(".vqr-tab")
      .off("click")
      .on("click", (e) => this.switchTab(e));

    // Submit quote confirmation
    $(".vqr-confirm-submit")
      .off("click")
      .on("click", () => this.confirmSubmitQuote());

    // Counter offer confirmation
    $(".vqr-confirm-counter")
      .off("click")
      .on("click", () => this.submitCounterOffer());

    // Accept offer confirmation
    $(".vqr-confirm-accept")
      .off("click")
      .on("click", () => this.handleAcceptOffer());

    // Mark all notifications read
    $(".vqr-mark-all-read")
      .off("click")
      .on("click", () => this.markAllRead());

    // Point Deduction Confirm
    $(".vqr-confirm-points-deduction")
      .off("click")
      .on("click", () => this.confirmPointDeduction());

    // Finalize Order Confirm
    $(".vqr-confirm-finalize-order")
      .off("click")
      .on("click", () => this.confirmFinalizeOrder());
  };

  // =========================================================================
  // TABS
  // =========================================================================

  switchTab = (e) => {
    const tab = $(e.currentTarget).data("tab");
    $(".vqr-tab").removeClass("active");
    $(e.currentTarget).addClass("active");
    $(".vqr-tab-content").addClass("d-none");

    if (tab === "available") {
      $(".vqr-available-content").removeClass("d-none");
      this.loadAvailableRequests();
    } else if (tab === "myquotes") {
      $(".vqr-myquotes-content").removeClass("d-none");
      this.loadMyQuotes();
    } else if (tab === "orders") {
      $(".vqr-orders-content").removeClass("d-none");
      this.loadOrders();
    } else if (tab === "notifications") {
      $(".vqr-notifications-content").removeClass("d-none");
      this.loadNotifications();
    }
  };

  // =========================================================================
  // AVAILABLE REQUESTS
  // =========================================================================

  loadAvailableRequests = () => {
    $.ajax({
      url: baseURL + "api/VendorQuote/requests",
      type: "GET",
      headers: { Authorization: X_API_KEY },
      success: (result) => {
        const requests = result?.data || [];
        const container = $(".vqr-available-list");
        container.empty();

        if (requests.length === 0) {
          $(".vqr-available-empty").removeClass("d-none");
          return;
        }

        $(".vqr-available-empty").addClass("d-none");
        requests.forEach((req) => {
          container.append(this.buildRequestCard(req));
        });

        // Bind submit quote buttons
        $(".vqr-submit-quote-btn")
          .off("click")
          .on("click", (e) => {
            const el = $(e.currentTarget);
            this.showSubmitModal(
              el.data("request-id"),
              el.data("description"),
              el.data("category"),
              el.data("location"),
            );
          });
      },
      error: () => $(".vqr-available-empty").removeClass("d-none"),
    });
  };

  buildRequestCard = (req) => {
    const timeAgo = this.timeAgo(req.created_at);
    const quoteCount = req.quote_count || 0;
    const categoryName = req.category_name || "General";
    const customerName = req.Customer_Name || "Customer";
    const description =
      req.description.length > 100
        ? req.description.substring(0, 100) + "..."
        : req.description;
    const expiresAt = new Date(req.expires_at);
    const now = new Date();
    const daysLeft = Math.max(
      0,
      Math.ceil((expiresAt - now) / (1000 * 60 * 60 * 24)),
    );

    return `
      <div class="card mb-3 vqr-request-card border-0 shadow-sm" style="border-radius: 12px;">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-start mb-2">
            <div class="d-flex align-items-center">
              <img src="${getImageUrl(req.customer_image)}" class="rounded-circle me-2" width="32" height="32" style="object-fit: cover; border: 1px solid #eee;">
              <span class="badge vqr-category-badge">${categoryName}</span>
            </div>
            <span class="text-muted small">${daysLeft}d left</span>
          </div>
          <p class="mb-2 fw-bold vqr-card-desc">${description}</p>
          ${
            req.image
              ? `<div class="mb-3 vqr-request-image-container">
                   <img src="${getImageUrl(req.image)}" class="img-fluid rounded shadow-sm vqr-request-image" 
                        style="max-height: 200px; width: 100%; object-fit: cover; cursor: pointer;"
                        onclick="window.open('${getImageUrl(req.image)}', '_blank')">
                 </div>`
              : ""
          }
          <div class="vqr-card-meta mb-2">
            <span class="me-3"><i class="fa fa-user me-1"></i>${customerName}</span>
            ${req.location ? `<span class="me-3"><i class="fa fa-map-marker-alt me-1"></i>${req.location}</span>` : ""}
            <span class="me-3"><i class="fa fa-clock me-1"></i>${timeAgo}</span>
            <span><i class="fa fa-comments me-1"></i>${quoteCount} quote${quoteCount !== 1 ? "s" : ""}</span>
          </div>
          <button class="btn btn-sm text-white vqr-submit-quote-btn" 
            data-request-id="${req.id}" data-description="${req.description.replace(/"/g, "&quot;")}"
            data-category="${categoryName}" data-location="${req.location || ""}"
            style="background: #ff385c; border-radius: 8px;">
            Submit Quote →
          </button>
        </div>
      </div>`;
  };

  showSubmitModal = (requestId, description, category, location) => {
    $("#vqrRequestId").val(requestId);
    $(".vqr-modal-request-desc").text(description);
    $(".vqr-modal-request-category").text(category);
    $(".vqr-modal-request-location").text(location || "Not specified");
    $("#vqrPrice").val("");
    $("#vqrEstimatedTime").val("");
    $("#vqrMessage").val("");
    window.$("#submitQuoteModal").modal("show");
  };

  confirmSubmitQuote = () => {
    const price = $("#vqrPrice").val();
    if (!price || parseFloat(price) <= 0) {
      alert("Please enter a valid price.");
      return;
    }
    $(".vqr-confirm-submit")
      .prop("disabled", true)
      .html(
        '<span class="spinner-border spinner-border-sm"></span> Submitting...',
      );
    $.ajax({
      url: baseURL + "api/VendorQuote/submit",
      type: "POST",
      data: {
        quote_request_id: $("#vqrRequestId").val(),
        price: price,
        estimated_time: $("#vqrEstimatedTime").val(),
        message: $("#vqrMessage").val(),
      },
      headers: { Authorization: X_API_KEY },
      success: () => {
        window.$("#submitQuoteModal").modal("hide");
        this.showToast("Quote submitted successfully!", "success");
        this.loadAvailableRequests();
      },
      error: (xhr) =>
        this.showToast(
          xhr.responseJSON?.message || "Failed to submit quote",
          "error",
        ),
      complete: () =>
        $(".vqr-confirm-submit").prop("disabled", false).html("Submit Quote"),
    });
  };

  // =========================================================================
  // MY QUOTES & NEGOTIATION
  // =========================================================================

  loadMyQuotes = () => {
    $.ajax({
      url: baseURL + "api/VendorQuote/myQuotes",
      type: "GET",
      headers: { Authorization: X_API_KEY },
      success: (result) => {
        const quotes = result?.data || [];
        // console.log("Loaded my quotes:", quotes);
        const container = $(".vqr-myquotes-list");
        container.empty();
        if (quotes.length === 0) {
          $(".vqr-myquotes-empty").removeClass("d-none");
          return;
        }
        $(".vqr-myquotes-empty").addClass("d-none");
        quotes.forEach((q) => container.append(this.buildMyQuoteCard(q)));

        // Bind Action Buttons
        $(".vqr-counter-btn")
          .off("click")
          .on("click", (e) => {
            const el = $(e.currentTarget);
            this.showCounterModal(el.data("quote-id"), el.data("price"));
          });
        $(".vqr-accept-btn")
          .off("click")
          .on("click", (e) => {
            const el = $(e.currentTarget);
            const negId = el.data("neg-id");
            if (!negId) {
              this.showToast(
                "Cannot accept this quote: negotiation record missing.",
                "warning",
              );
              return;
            }
            this.showAcceptModal(negId, el.data("price"));
          });

        $(".vqr-pay-btn")
          .off("click")
          .on("click", (e) => {
            const orderId = $(e.currentTarget).data("order-id");
            this.showFinalizeModal(orderId);
          });

        $(".vqr-view-history")
          .off("click")
          .on("click", (e) => {
            this.showHistoryModal($(e.currentTarget).data("quote-id"));
          });
      },
    });
  };

  buildMyQuoteCard = (q) => {
    const negStatus = q.negotiation_status || "PENDING";
    const displayStatus = q.status || negStatus;
    const statusClass = this.getStatusClass(displayStatus);
    const categoryName = q.category_name || "General";
    const isVendorTurn = q.sender_type === "CUSTOMER";
    const currentPrice = q.current_price || q.price;

    let actionButtons = "";
    const isAwaitingPayment = q.order_status === "AWAITING VENDOR POINTS";

    if (negStatus === "PENDING") {
      if (isVendorTurn) {
        actionButtons = `
          <div class="row g-2 mt-2">
            <div class="col-6">
              <button class="btn btn-sm btn-outline-primary w-100 vqr-counter-btn" data-quote-id="${q.id}" data-price="${currentPrice}">Counter</button>
            </div>
            <div class="col-6">
              <button class="btn btn-sm btn-success w-100 vqr-accept-btn" data-neg-id="${q.latest_neg_id}" data-price="${currentPrice}">Accept</button>
            </div>
          </div>`;
      } else {
        actionButtons = `<div class="mt-2 text-center small text-muted font-italic"><i class="fa fa-hourglass-half me-1"></i>Waiting for Customer...</div>`;
      }
    } else if (isAwaitingPayment) {
      actionButtons = `
        <div class="mt-2">
          <button class="btn btn-sm btn-warning w-100 vqr-pay-btn fw-bold" data-order-id="${q.order_id}">
            <i class="fa fa-wallet me-1"></i> Pay to Close Deal
          </button>
        </div>`;
    }

    return `
      <div class="card mb-3 vqr-myquote-card border-0 shadow-sm" style="border-radius: 12px;">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-start mb-2">
            <div class="d-flex align-items-center">
              <img src="${getImageUrl(q.customer_image)}" class="rounded-circle me-2" width="32" height="32" style="object-fit: cover; border: 1px solid #eee;">
              <span class="badge vqr-category-badge">${categoryName}</span>
            </div>
            <span class="badge ${statusClass}">${displayStatus}</span>
          </div>
          <p class="mb-1 fw-bold">${q.request_description?.substring(0, 80) || "Service Request"}...</p>
          <div class="bg-light p-2 rounded mb-2 d-flex justify-content-between align-items-center">
            <span class="small text-muted">Current Negotiated Price:</span>
            <span class="fw-bold text-primary">₹${parseFloat(currentPrice).toLocaleString("en-IN")}</span>
          </div>
          ${q.last_message ? `<div class="small text-muted mb-2 border-start ps-2 font-italic">"${q.last_message}"</div>` : ""}
          <div class="d-flex justify-content-between align-items-center mt-3">
            <a href="javascript:void(0)" class="small vqr-view-history fw-bold" data-quote-id="${q.id}">View History</a>
            <span class="text-muted small">${this.timeAgo(q.created_at)}</span>
          </div>
          ${actionButtons}
        </div>
      </div>`;
  };

  showCounterModal = (quoteId, lastPrice) => {
    $("#vqrCounterQuoteId").val(quoteId);
    $(".vqr-counter-last-price").text(
      parseFloat(lastPrice).toLocaleString("en-IN"),
    );
    $("#vqrCounterPrice").val("");
    $("#vqrCounterMessage").val("");
    window.$("#vendorCounterModal").modal("show");
  };

  submitCounterOffer = () => {
    const price = $("#vqrCounterPrice").val();
    if (!price || price <= 0) {
      alert("Please enter a valid price.");
      return;
    }
    $(".vqr-confirm-counter").prop("disabled", true).text("Sending...");
    $.ajax({
      url: baseURL + "api/VendorQuote/counter",
      type: "POST",
      data: {
        quote_id: $("#vqrCounterQuoteId").val(),
        price: price,
        message: $("#vqrCounterMessage").val(),
      },
      headers: { Authorization: X_API_KEY },
      success: () => {
        window.$("#vendorCounterModal").modal("hide");
        this.showToast("Counter offer sent!", "success");
        this.loadMyQuotes();
      },
      error: () => this.showToast("Failed to send counter offer.", "error"),
      complete: () =>
        $(".vqr-confirm-counter").prop("disabled", false).text("Send Counter"),
    });
  };

  showAcceptModal = (negId, price) => {
    $("#vqrAcceptNegId").val(negId);
    $(".vqr-accept-price").text(parseFloat(price).toLocaleString("en-IN"));
    console.log('[VQR] Showing Accept Modal for negId:', negId);
    this.safeShowModal("vendorAcceptModal");
  };

  handleAcceptOffer = () => {
    const negId = $("#vqrAcceptNegId").val();
    const btn = $(".vqr-confirm-accept");
    btn.prop("disabled", true).text("Processing...");

    console.log('[VQR] Accepting offer:', negId);
    $.ajax({
      url: baseURL + "api/VendorQuote/acceptOffer",
      type: "POST",
      data: { negotiation_id: negId },
      headers: { Authorization: X_API_KEY },
      success: (res) => {
        console.log('[VQR] AcceptOffer Response:', res);
        if (res.type === "DEDUCTION_REQUIRED") {
          this.safeHideModal("vendorAcceptModal");
          // Ensure previous modal is hidden before showing next one
          setTimeout(() => {
            this.showPointDeductionModal(negId, res.fee, res.balance);
          }, 500);
        } else if (res.success === true || res.success === "true") {
          this.safeHideModal("vendorAcceptModal");
          this.showToast("Offer accepted!", "success");
          this.loadMyQuotes();
        } else {
          this.showToast(res.message || res.Msg || "Failed to accept offer.", "error");
        }
      },
      error: (err) => {
        console.error('[VQR] AcceptOffer Error:', err);
        this.showToast("Failed to accept offer.", "error");
      },
      complete: () => btn.prop("disabled", false).text("Yes, Accept Offer"),
    });
  };

  showPointDeductionModal = (negId, fee, balance) => {
    console.log('[VQR] showPointDeductionModal:', { negId, fee, balance });
    this.pendingNegId = negId;
    $(".vqr-deduction-fee").text(fee);
    $(".vqr-current-balance").text(balance);

    if (balance < fee) {
      $(".vqr-insufficient-balance").removeClass("d-none");
      $(".vqr-confirm-points-deduction").addClass("d-none");
      $(".vqr-top-up-btn").removeClass("d-none");
    } else {
      $(".vqr-insufficient-balance").addClass("d-none");
      $(".vqr-confirm-points-deduction").removeClass("d-none");
      $(".vqr-top-up-btn").addClass("d-none");
    }

    // Bind top-up button
    $(".vqr-top-up-btn").off("click").on("click", () => {
      this.safeHideModal("vqrPointDeductionModal");
      $(".vendor-payments").click(); // Trigger sidebar navigation
    });

    this.safeShowModal("vqrPointDeductionModal");
  };

  confirmPointDeduction = () => {
    const btn = $(".vqr-confirm-points-deduction");
    btn.prop("disabled", true).text("Processing...");

    $.ajax({
      url: baseURL + "api/VendorQuote/acceptOffer",
      type: "POST",
      data: {
        negotiation_id: this.pendingNegId,
        confirm_deduction: true,
      },
      headers: { Authorization: X_API_KEY },
      success: (res) => {
        if (res.success) {
          window.$("#vqrPointDeductionModal").modal("hide");
          this.showToast("Points deducted and offer accepted!", "success");
          this.loadMyQuotes();
          this.loadOrders();
        } else {
          this.showToast(res.message || "Deduction failed.", "error");
        }
      },
      error: () => this.showToast("Failed to process deduction.", "error"),
      complete: () => btn.prop("disabled", false).text("Pay & Confirm"),
    });
  };

  showHistoryModal = (quoteId) => {
    window.$("#vendorHistoryModal").modal("show");
    const container = $(".vqr-history-list");
    container.html(
      '<div class="text-center py-3"><div class="spinner-border spinner-border-sm text-primary"></div></div>',
    );
    $.ajax({
      url: baseURL + "api/customer/CustomerQuote/negotiations", // Shared endpoint
      type: "GET",
      data: { quote_id: quoteId },
      headers: { Authorization: X_API_KEY },
      success: (res) => {
        const history = res?.data || [];
        container.empty();
        if (history.length === 0) {
          container.html(
            '<p class="text-center text-muted">No history found.</p>',
          );
          return;
        }
        history.forEach((h) => {
          const isVendor = h.sender_type === "VENDOR";
          container.append(`
            <div class="mb-3 d-flex flex-column ${isVendor ? "ms-auto text-end" : "me-auto"}" style="max-width: 80%;">
              <div class="small fw-bold mb-1">${isVendor ? "You" : "Customer"}</div>
              <div class="p-2 rounded ${isVendor ? "bg-primary text-white" : "bg-light"}">
                <div class="fw-bold mb-1">₹${parseFloat(h.price).toLocaleString("en-IN")}</div>
                ${h.message ? `<div class="small">${h.message}</div>` : ""}
              </div>
              <div class="text-muted" style="font-size: 0.7rem;">${this.timeAgo(h.created_at)}</div>
            </div>`);
        });
      },
      error: () =>
        container.html(
          '<p class="text-center text-danger">Failed to load history.</p>',
        ),
    });
  };

  // =========================================================================
  // ORDERS
  // =========================================================================

  loadOrders = () => {
    const container = $(".vqr-orders-list");
    container.html(
      '<div class="text-center py-5"><div class="spinner-border text-primary"></div></div>',
    );

    $.ajax({
      url: baseURL + "api/VendorQuote/orders",
      type: "GET",
      headers: { Authorization: X_API_KEY },
      success: (res) => {
        const orders = res?.data || [];
        container.empty();
        if (orders.length === 0) {
          $(".vqr-orders-empty").removeClass("d-none");
          return;
        }

        $(".vqr-orders-empty").addClass("d-none");
        orders.forEach((order) => {
          container.append(this.buildOrderCard(order));
        });

        // Bind Itemize buttons
        $(".vqr-itemize-btn")
          .off("click")
          .on("click", (e) => {
            const btn = $(e.currentTarget);
            this.showItemizeModal(
              btn.data("order-id"),
              btn.data("final-price"),
            );
          });

        // Bind Finalize buttons
        $(".vqr-finalize-btn")
          .off("click")
          .on("click", (e) => {
            const btn = $(e.currentTarget);
            this.showFinalizeModal(btn.data("order-id"));
          });
      },
      error: () =>
        container.html(
          '<p class="text-center text-danger py-5">Failed to load orders.</p>',
        ),
    });
  };

  buildOrderCard = (order) => {
    const isAwaitingPayment = order.Order_Status === "AWAITING VENDOR POINTS";

    let primaryAction = "";
    if (isAwaitingPayment) {
      primaryAction = `
        <button class="btn btn-warning btn-sm flex-grow-1 rounded-pill vqr-finalize-btn" 
                data-order-id="${order.Order_ID}">
          <i class="fa fa-wallet me-1"></i> Pay to Finalize
        </button>`;
    } else if (order.items_locked == 0) {
      primaryAction = `
        <button class="btn btn-primary btn-sm flex-grow-1 rounded-pill vqr-itemize-btn" 
                data-order-id="${order.Order_ID}" data-final-price="${order.final_price}">
          <i class="fa fa-list-check me-1"></i> Itemize Order
        </button>`;
    } else {
      primaryAction = `
        <button class="btn btn-outline-success btn-sm flex-grow-1 rounded-pill disabled" style="cursor: default; opacity: 0.8 !important;">
          <i class="fa fa-check-circle me-1"></i> Itemized & Locked
        </button>`;
    }

    return `
      <div class="card mb-3 border-0 shadow-sm" style="border-radius: 15px; overflow: hidden;">
        <div class="card-body p-3">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <div>
              <h6 class="mb-0 fw-bold">${order.Customer_Name || "Customer"}</h6>
              <div class="small text-muted">Order #${order.Order_No}</div>
            </div>
            <div class="text-end">
              <span class="badge ${this.getStatusBadgeClass(order.Order_Status)}">${order.Order_Status}</span>
            </div>
          </div>

          <div class="bg-light p-2 rounded mb-3">
            <div class="d-flex justify-content-between small mb-1">
              <span>Final Price:</span>
              <strong class="text-primary">₹${parseFloat(order.final_price).toLocaleString("en-IN")}</strong>
            </div>
            <div class="d-flex justify-content-between small text-truncate">
              <span>Date:</span>
              <span class="text-muted ms-2">${new Date(order.createdAt).toLocaleDateString()}</span>
            </div>
          </div>

          <div class="d-flex gap-2">
            ${primaryAction}
            <button class="btn btn-outline-secondary btn-sm rounded-pill" onclick="window.location.hash='#chat/${order.Customer_ID}'">
              <i class="fa fa-comment"></i>
            </button>
          </div>
        </div>
      </div>`;
  };

  showFinalizeModal = (orderId) => {
    console.log('[VQR] showFinalizeModal for orderId:', orderId);
    $("#vqrFinalizeOrderId").val(orderId);
    
    // Fetch current balance from dedicated balance endpoint
    $.ajax({
      url: baseURL + "api/VendorQuote/balance",
      type: "GET",
      headers: { Authorization: X_API_KEY },
      success: (res) => {
        console.log('[VQR] Balance response:', res);
        const balance = parseInt(res.balance) || 0;
        const fee = 50; // Should ideally come from an API or constant, using 50 as per user's latest change
        
        $(".vqr-finalize-fee").text(fee);
        $(".vqr-current-balance-f").text(balance);

        if (balance < fee) {
          $(".vqr-confirm-finalize-order").addClass("d-none");
          $(".vqr-top-up-btn-f").removeClass("d-none");
          $(".vqr-insufficient-balance-f").removeClass("d-none");
        } else {
          $(".vqr-confirm-finalize-order").removeClass("d-none");
          $(".vqr-top-up-btn-f").addClass("d-none");
          $(".vqr-insufficient-balance-f").addClass("d-none");
        }

        // Bind top-up button
        $(".vqr-top-up-btn-f").off("click").on("click", () => {
          this.safeHideModal("vqrFinalizeOrderModal");
          $(".vendor-payments").click(); 
        });

        this.safeShowModal("vqrFinalizeOrderModal");
      },
      error: (err) => {
        console.error('[VQR] Balance fetch error:', err);
        this.showToast("Failed to fetch wallet balance.", "error");
      }
    });
  };

  // =========================================================================
  // MODAL UTILITIES
  // =========================================================================
  
  safeShowModal = (modalId) => {
    const el = document.getElementById(modalId);
    if (!el) {
      console.error(`[VQR] Modal element #${modalId} not found in DOM!`);
      return;
    }
    
    // Ensure parent container is not hidden
    $(".vendorQuoteRequestsPage").removeClass("d-none");

    try {
      if (window.$ && typeof window.$.fn.modal === 'function') {
        window.$(el).modal('show');
      } else if (window.bootstrap && window.bootstrap.Modal) {
        const m = new window.bootstrap.Modal(el);
        m.show();
      } else {
        console.error('[VQR] No modal manager (jQuery or Bootstrap) found!');
      }
    } catch (e) {
      console.error(`[VQR] Exception showing modal #${modalId}:`, e);
    }
  };

  safeHideModal = (modalId) => {
    const el = document.getElementById(modalId);
    if (!el) return;
    
    try {
      if (window.$ && typeof window.$.fn.modal === 'function') {
        window.$(el).modal('hide');
      } else if (window.bootstrap && window.bootstrap.Modal) {
        const m = window.bootstrap.Modal.getInstance(el);
        if (m) m.hide();
      }
    } catch (e) {
      console.error(`[VQR] Exception hiding modal #${modalId}:`, e);
    }
  };

  confirmFinalizeOrder = () => {
    const orderId = $("#vqrFinalizeOrderId").val();
    const btn = $(".vqr-confirm-finalize-order");
    btn.prop("disabled", true).text("Processing...");

    $.ajax({
      url: baseURL + "api/VendorQuote/finalizeWithPoints",
      type: "POST",
      data: { order_id: orderId },
      headers: { Authorization: X_API_KEY },
      success: (res) => {
        if (res.success) {
          window.$("#vqrFinalizeOrderModal").modal("hide");
          this.showToast("Deal finalized and points deducted!", "success");
          this.loadOrders();
        } else {
          this.showToast(res.Msg || res.message || "Finalization failed.", "error");
        }
      },
      error: () => this.showToast("Failed to finalize order.", "error"),
      complete: () => btn.prop("disabled", false).text("Pay & Finalize"),
    });
  };

  getStatusBadgeClass = (status) => {
    switch (status) {
      case "QUOTE ORDER":
        return "bg-primary-soft text-primary";
      case "AWAITING VENDOR POINTS":
        return "bg-warning-soft text-warning";
      case "COMPLETED":
        return "bg-success-soft text-success";
      case "CANCELLED":
        return "bg-danger-soft text-danger";
      default:
        return "bg-light text-muted";
    }
  };

  // =========================================================================
  // ITEMIZATION LOGIC
  // =========================================================================

  showItemizeModal = (orderId, finalPrice) => {
    this.currentOrderId = orderId;
    this.targetTotal = parseFloat(finalPrice);

    $("#vqrNegotiatedPrice").text(this.targetTotal.toLocaleString("en-IN"));
    $("#vqrItemizationRows").empty();
    $("#vqrItemizationError").addClass("d-none");

    // Fetch existing items before showing
    $.ajax({
      url: baseURL + "api/vendor/orderedProducts",
      type: "GET",
      data: { Order_ID: orderId },
      headers: { Authorization: X_API_KEY },
      success: (res) => {
        // Filter out auto-itemized placeholder rows
        const products = (res || []).filter(
          (p) => parseInt(p.is_auto_itemized) !== 1,
        );
        if (products.length > 0) {
          products.forEach((p) => this.addItemizationRow(p));
        } else {
          this.addItemizationRow(); // Default empty row
        }
        this.calculateItemizationTotal();
      },
      error: () => {
        this.addItemizationRow();
        this.calculateItemizationTotal();
      },
    });

    window.$("#itemizeOrderModal").modal("show");

    // Re-bind modal-specific events
    $("#vqrAddExtraItem")
      .off("click")
      .on("click", () => this.addItemizationRow());
    $("#vqrSubmitItemization")
      .off("click")
      .on("click", () => this.submitItemization());
  };

  addItemizationRow = (item = null) => {
    const rowId = "row_" + Date.now() + "_" + Math.floor(Math.random() * 1000);
    const name = item ? item.ProductName || item.custom_name || "" : "";
    const qty = item ? item.Quantity || 1 : 1;
    const price = item ? item.Price || "" : "";

    const html = `
      <tr id="${rowId}" class="itemization-row">
        <td>
          <input type="text" class="form-control form-control-sm border-0 bg-light rounded-pill px-3 item-name" 
                 placeholder="E.g. Service Title" value="${name}">
        </td>
        <td class="text-center">
          <input type="number" class="form-control form-control-sm border-0 bg-light rounded-pill text-center item-qty" 
                 value="${qty}" min="1">
        </td>
        <td>
          <input type="number" class="form-control form-control-sm border-0 bg-light rounded-pill text-end item-price" 
                 placeholder="0.00" value="${price}">
        </td>
        <td class="text-center">
          <button type="button" class="btn btn-link text-danger p-0 delete-row"><i class="fa fa-times-circle"></i></button>
        </td>
      </tr>
    `;
    $("#vqrItemizationRows").append(html);

    // Bind row events
    $(`#${rowId} input`).on("input", () => this.calculateItemizationTotal());
    $(`#${rowId} .delete-row`).on("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      if ($(".itemization-row").length > 1) {
        $(`#${rowId}`).remove();
        this.calculateItemizationTotal();
      }
    });
  };

  calculateItemizationTotal = () => {
    let currentTotal = 0;
    $(".itemization-row").each(function () {
      const qty = parseFloat($(this).find(".item-qty").val()) || 0;
      const price = parseFloat($(this).find(".item-price").val()) || 0;
      currentTotal += qty * price;
    });

    $("#vqrRunningTotal").text(currentTotal.toLocaleString("en-IN"));
    const diff = currentTotal - this.targetTotal;
    const diffBox = $("#vqrItemizationDiff");

    if (Math.abs(diff) < 0.01) {
      diffBox.html(
        '<span class="text-success small fw-bold"><i class="fa fa-check-circle"></i> Ready to Finalize</span>',
      );
      $("#vqrRunningTotal").addClass("text-success").removeClass("text-danger");
      $("#vqrItemizationError").addClass("d-none");
    } else {
      const sign = diff > 0 ? "+" : "";
      diffBox.html(
        `<span class="text-danger small fw-bold">${sign}${diff.toLocaleString("en-IN")} difference</span>`,
      );
      $("#vqrRunningTotal").addClass("text-danger").removeClass("text-success");
    }
  };

  submitItemization = () => {
    const items = [];
    let currentTotal = 0;
    let isValid = true;

    $(".itemization-row").each(function () {
      const name = $(this).find(".item-name").val();
      const qty = parseFloat($(this).find(".item-qty").val()) || 0;
      const price = parseFloat($(this).find(".item-price").val()) || 0;

      if (!name || price <= 0) isValid = false;

      items.push({
        custom_name: name,
        Quantity: qty,
        Price: price,
      });
      currentTotal += qty * price;
    });

    if (!isValid) {
      this.showToast("All items must have a name and price.", "warning");
      return;
    }

    if (Math.abs(currentTotal - this.targetTotal) > 0.01) {
      $("#vqrItemizationError").removeClass("d-none");
      this.showToast("Totals must match exactly.", "error");
      return;
    }

    const btn = $("#vqrSubmitItemization");
    btn.prop("disabled", true).text("Finalizing...");

    $.ajax({
      url: baseURL + "api/VendorQuote/submitItemization",
      type: "POST",
      data: {
        order_id: this.currentOrderId,
        items: items,
      },
      headers: { Authorization: X_API_KEY },
      success: (res) => {
        if (res.success) {
          this.showToast("Itemization finalized!", "success");
          window.$("#itemizeOrderModal").modal("hide");
          this.loadOrders();
        } else {
          this.showToast(
            res.message || res.Msg || "Failed to finalize.",
            "error",
          );
        }
      },
      error: (err) =>
        this.showToast(
          "Error: " + (err.responseJSON?.Msg || "Submission failed"),
          "error",
        ),
      complete: () => btn.prop("disabled", false).text("Finalize Itemization"),
    });
  };

  // =========================================================================
  // NOTIFICATIONS
  // =========================================================================

  loadNotificationBadge = () => {
    $.ajax({
      url: baseURL + "api/VendorQuote/notifications",
      type: "GET",
      data: { limit: 1 },
      headers: { Authorization: X_API_KEY },
      success: (result) => {
        const unread = result?.data?.unread_count || 0;
        unread > 0
          ? $(".vqr-notif-badge").text(unread).removeClass("d-none")
          : $(".vqr-notif-badge").addClass("d-none");
      },
    });
  };

  loadNotifications = () => {
    $.ajax({
      url: baseURL + "api/VendorQuote/notifications",
      type: "GET",
      headers: { Authorization: X_API_KEY },
      success: (result) => {
        const notifications = result?.data?.notifications || [];
        const container = $(".vqr-notifications-list");
        container.empty();
        if (notifications.length === 0) {
          container.html(
            '<p class="text-center text-muted py-3">No notifications</p>',
          );
          return;
        }
        notifications.forEach((n) => {
          const readClass =
            n.is_read == 1 ? "vqr-notif-read" : "vqr-notif-unread";
          container.append(`
            <div class="card mb-2 vqr-notif-card ${readClass}">
              <div class="card-body py-2 px-3">
                <div class="d-flex justify-content-between">
                  <strong class="small">${n.title}</strong>
                  <small class="text-muted">${this.timeAgo(n.created_at)}</small>
                </div>
                <p class="mb-0 small text-muted">${n.message || ""}</p>
              </div>
            </div>`);
        });
      },
    });
  };

  markAllRead = () => {
    $.ajax({
      url: baseURL + "api/VendorQuote/markNotificationRead",
      type: "POST",
      data: { notification_id: "all" },
      headers: { Authorization: X_API_KEY },
      success: () => {
        $(".vqr-notif-badge").addClass("d-none");
        this.loadNotifications();
      },
    });
  };

  // =========================================================================
  // HELPERS
  // =========================================================================

  getStatusClass = (status) => {
    switch (status) {
      case "PENDING":
        return "bg-warning text-dark";
      case "ACCEPTED":
      case "CONFIRMED":
      case "SELECTED":
        return "bg-primary";
      case "REJECTED":
      case "CANCELLED":
        return "bg-danger";
      case "IN_PROGRESS":
        return "bg-info text-white";
      case "COMPLETED":
        return "bg-primary";
      default:
        return "bg-secondary";
    }
  };

  timeAgo = (dateStr) => {
    if (!dateStr) return "";
    const now = new Date();
    const date = new Date(dateStr);
    const seconds = Math.floor((now - date) / 1000);
    if (seconds < 60) return "just now";
    if (seconds < 3600) return Math.floor(seconds / 60) + "m ago";
    if (seconds < 86400) return Math.floor(seconds / 3600) + "h ago";
    if (seconds < 604800) return Math.floor(seconds / 86400) + "d ago";
    return date.toLocaleDateString("en-IN", { day: "numeric", month: "short" });
  };

  showToast = (message, type = "success") => {
    const bg = type === "success" ? "#28a745" : "#dc3545";
    const toast = $(
      `<div class="vqr-toast" style="background: ${bg};">${message}</div>`,
    );
    $("body").append(toast);
    setTimeout(() => toast.addClass("show"), 10);
    setTimeout(() => {
      toast.removeClass("show");
      setTimeout(() => toast.remove(), 300);
    }, 3000);
  };
}

